import {
  ARB_IN_UAE_LOADER,
  DOWNLOAD_COUNT,
  SET_ARB_IN_UAE_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  pageData: {},
};

const arbitrationInUAEReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARB_IN_UAE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_ARB_IN_UAE_DATA: {
      return {
        ...state,
        pageData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          pageData: {
            ...state.pageData,
            fileViewCount: (state.pageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          pageData: {
            ...state.pageData,
            downloadCount: (state.pageData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default arbitrationInUAEReducer;
